<template>
	<div>
        <div class="row">
            <el-card class="pt-1 pb-4" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/profit-laba')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/tingkat-kesehatan')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center">KINERJA REVENUE & LABA KONSOLIDASI YTD {{ this.options.months.find(d=> d.value==this.month).name.toUpperCase() }} {{ this.year}}</h4>

                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.chart" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                        <div class="col-md-6 text-right" v-if="lastUpdate != ''">
                            <el-form-item label=" ">
                                <div v-html="lastUpdate"></div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <div class="row mt-4">
                    <div class="col-md-6">
                       <h5 class="text-center">REVENUE YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year }}</h5>
                       <LineChart v-loading.body="loading.chart" :data="chartdatarevenue" :width="500" :height="250" style="margin-top:20px;"/>
                       <div class="mt-4 ml-4 mr-4 p-3" style="background:#B4C7E7;color:#000;border-top-left-radius:10px;border-bottom-right-radius:10px;">
                            Revenue Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year}} <b>Rp. {{ this.description.revenue.Realization}}</b> atau <b>{{ formatNum(this.description.revenue.RKAPAchievement)}}%</b> thd RKAP Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year}} <b>Rp. {{ this.description.revenue.RKAPYtd}}</b> dan <b>{{ formatNum(this.description.revenue.RealizationDiv)}}%</b> thd Real Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year-1}} <b>Rp. {{ this.description.revenue.RealizationYtdBefore}}</b>.
                       </div>
                    </div>

                    <div class="col-md-6" >
                        <h5 class="text-center">LABA YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year }}</h5>
                        <LineChart v-loading.body="loading.chartlaba" :data="chartdatalaba" :width="500" :height="250" style="margin-top:20px;"/>
                        <div class="mt-4 ml-4 mr-4 p-3" style="background:#B4C7E7;color:#000;border-top-left-radius:10px;border-bottom-right-radius:10px;">
                            Laba Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year}} <b>Rp. {{ this.description.laba.Realization}}</b> atau <b>{{ formatNum(this.description.laba.RKAPAchievement) }}%</b> thd RKAP Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year}} <b>Rp. {{ this.description.laba.RKAPYtd}}</b> dan <b>{{ formatNum(this.description.laba.RealizationDiv)}}%</b> thd Real Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year-1}} <b>Rp. {{ this.description.laba.RealizationYtdBefore}}</b>.
                        </div>
                    </div>
                </div>
            </el-card>

        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        LineChart,
		//ReportParamSelect,
	},

	data() {
		return {
            columnWidth : 120,
            chartdata: [],
            loading: {
                chart: false,
                chartlaba: false,
            },

            description: {
                revenue: {
                    Realization: 0,
                    RKAPAchievement: 0,
                    RKAPYtd: 0,
                    RealizationDiv: 0,
                    RealizationYtdBefore: 0,
                },
                laba: {
                    Realization: 0,
                    RKAPAchievement: 0,
                    RKAPYtd: 0,
                    RealizationDiv: 0,
                    RealizationYtdBefore: 0,
                },
            },

            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,

            chartdatarevenue: [],
            chartdatalaba: [],

            //sample
            chartdata1:[
                {
                    label: 'Jan',
                    legend: 'Real 2022',
                    valuecol: 1372104.677716,
                },
                {
                    label: 'Jan',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Jan',
                    legend: 'RKAP 2023',
                    valuecol: 1571510.7368292,
                },
                {
                    label: 'Feb',
                    legend: 'Real 2022',
                    valuecol: 1129519.47135389,
                },
                {
                    label: 'Feb',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Feb',
                    legend: 'RKAP 2023',
                    valuecol: 1590116.88494448,
                },

                {
                    label: 'Mar',
                    legend: 'Real 2022',
                    valuecol: 1453037.55907502,
                },
                {
                    label: 'Mar',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Mar',
                    legend: 'RKAP 2023',
                    valuecol: 1876960.45365207,
                },

                {
                    label: 'Apr',
                    legend: 'Real 2022',
                    valuecol: 1508651.93535995,
                },
                {
                    label: 'Apr',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Apr',
                    legend: 'RKAP 2023',
                    valuecol: 1869339.12573834,
                },

                {
                    label: 'Mei',
                    legend: 'Real 2022',
                    valuecol: 1597474.47737616,
                },
                {
                    label: 'Mei',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Mei',
                    legend: 'RKAP 2023',
                    valuecol: 1822876.51767075,
                },
            ],

            chartdata2:[
                {
                    label: 'Jan',
                    legend: 'Real 2022',
                    valuecol:  40.214,
                },
                {
                    label: 'Jan',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Jan',
                    legend: 'RKAP 2023',
                    valuecol:  23.730,
                },

                {
                    label: 'Feb',
                    legend: 'Real 2022',
                    valuecol:  19.317,
                },
                {
                    label: 'Feb',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Feb',
                    legend: 'RKAP 2023',
                    valuecol:  23.439,
                },

                {
                    label: 'Mar',
                    legend: 'Real 2022',
                    valuecol:  59.817,
                },
                {
                    label: 'Mar',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Mar',
                    legend: 'RKAP 2023',
                    valuecol:  26.564,
                },

                {
                    label: 'Apr',
                    legend: 'Real 2022',
                    valuecol:  47.110,
                },
                {
                    label: 'Apr',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Apr',
                    legend: 'RKAP 2023',
                    valuecol:  29.723,
                },

                {
                    label: 'Mei',
                    legend: 'Real 2022',
                    valuecol:  34.877,
                },
                {
                    label: 'Mei',
                    legend: 'Real 2023',
                    valuecol: 0,
                },
                {
                    label: 'Mei',
                    legend: 'RKAP 2023',
                    valuecol:  22.513,
                },
            ],

        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        //this.setChart()
        this.setDefaultPeriod()
        this.getRevenueChart()
        this.getLabaChart()
    },
    methods: {
        setChart() {
            //sample
            this.chartdatarevenue = this.processBarChart(this.chartdata1, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatalaba = this.processBarChart(this.chartdata2, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
        },

        getRevenueChart() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/chart-revenue?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.chart = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let reportData = response.data;
                this.chartdata1 = reportData.data

                this.chartdatarevenue = this.processBarChart(this.chartdata1, "legend", "", "value", false, "label", "", 1, 2, this.colors, false, false, false, false);
                //console.log('data: ' + JSON.stringify(this.reportData))
                this.lastUpdate = reportData.last_update

                //set description
                this.description.revenue = reportData.description
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.chart = false;
			})     

        },

        getLabaChart() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/chart-laba?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.chartlaba = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let reportData = response.data;
                this.chartdata2 = reportData.data

                this.chartdatalaba = this.processBarChart(this.chartdata2, "legend", "", "value", false, "label", "", 1, 2, this.colors, false, false, false, false);
                //console.log('data: ' + JSON.stringify(this.reportData))

                //set description
                this.description.laba = reportData.description
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.chartlaba = false;
			})     

        },

        setDefaultPeriod() {
            // Mengecek apakah key sudah ada di localStorage
            if (localStorage.getItem('performanceDefaultMonth') !== null && localStorage.getItem('performanceDefaultYear') !== null) {
                //console.log('Period sudah ada di localStorage');
                let month = localStorage.getItem('performanceDefaultMonth')
                let year = localStorage.getItem('performanceDefaultYear')

                this.month = month
                this.year =  year
            } else {
                //console.log('period belum ada di localStorage');
            }
        },

        applyFilter() {
            this.getRevenueChart()
            this.getLabaChart()
        }

    },
}
</script>